import Cookies from 'universal-cookie';

const AUTH_TOKEN_COOKIE = `js_auth_token`;

const AUTH_HEADER = `auth-token`;

const TRANSACTION_HEADER = 'transaction-id';

const SYSTEM_COOKIE = 'g4_syskey';

const SYSTEM_HEADER = 'g4-sys-key';

const LOGOUT_PATH = '/user/logout';

const CLAIM_MY_POINT_COOKIE = 'claim-my-point-user';

const onLogout = () => {
  const cookies = new Cookies(document && document.cookie);
  cookies.remove(AUTH_TOKEN_COOKIE);
};

const redirectToLogin = () => {
  window.location.replace('/');
};

const messageAuthErrorRegex = /Authentication needed/g;
const debugMessageAuthErrorRegex = /Authentication denied/g;

const isUnauthenticated = ({ debugMessage, message, locations, path }) => {
  return (
    messageAuthErrorRegex.test(message) ||
    debugMessageAuthErrorRegex.test(debugMessage)
  );
};

const extractTokens = () => {
  let cookies;
  if (typeof window !== 'undefined') {
    cookies = new Cookies(document && document.cookie);
  } else {
    cookies = new Cookies();
  }

  const authToken = cookies.get(AUTH_TOKEN_COOKIE);
  const transactionId = authToken ? authToken.slice(-30) : null;
  const systemKey = cookies.get(SYSTEM_COOKIE);
  return {
    authToken,
    transactionId,
    systemKey,
  };
};

export {
  AUTH_TOKEN_COOKIE,
  SYSTEM_COOKIE,
  AUTH_HEADER,
  TRANSACTION_HEADER,
  SYSTEM_HEADER,
  LOGOUT_PATH,
  CLAIM_MY_POINT_COOKIE,
  isUnauthenticated,
  redirectToLogin,
  extractTokens,
  messageAuthErrorRegex,
  debugMessageAuthErrorRegex,
  onLogout,
};
